import React, {useEffect, useRef, useState} from "react";
import IconHeading from "../../Icons/IconHeading";
import LocationSearchField from "../../shared/LocationSearch/LocationSearchField";
import GoogleMapsAPILoader from "../../shared/GoogleMapsAPILoader/GoogleMapsAPILoader";
import ParticipantInput from "../../shared/ParticipantSelector/ParticipantInput";
import apiGet from "../../shared/api/apiGet";
import {ENDPOINT_CONFIGS} from "../../shared/consts/apiConsts";
import Loading from "../../shared/Loader/Loading";
import {bookingMinDate} from "../../shared/days/days";
import validatePax from "../../shared/ValidatePax/validatePax";
import TimeField from "../../shared/TimeField/TimeField";
import dataLayerHandler, {
  TRIP_PICKUP,
  TRIP_DROPOFF,
  TRIP_DATE,
  TRIP_TIME,
  TRIP_PAX,
  TRIP_TERMINAL,
  TRIP_SEARCH
} from "../../shared/dataLayer/dataLayerHandler";
import participantString from "../../shared/participantString/participantString";

const BookingInitialSearch = (props) => {

  const {
    charter
  } = props;

  const [configs, setConfigs] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const [startLat, setStartLat] = useState('');
  const [startLng, setStartLng] = useState('');
  const [startAddress, setStartAddress] = useState('');

  const [endLat, setEndLat] = useState('');
  const [endLng, setEndLng] = useState('');
  const [endAddress, setEndAddress] = useState('');

  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [terminal, setTerminal] = useState(null);
  const [isStartAirport, setIsStartAirport] = useState(false);
  const [isEndAirport, setIsEndAirport] = useState(false);

  const [pax, setPax] = useState([]);
  const [controller, setController] = useState(undefined);
  const [paxError, setPaxError] = useState(null);

  const paxInput = useRef();



  const handleAbortController = () => {
    if (controller) {
      controller.abort();
    }
    const ctrl = new AbortController();
    setController(ctrl);
    return ctrl;
  }

  const validateSubmit = (e) => {
    const validPax = validatePax(pax);
    if (!validPax[0]) {
      e.preventDefault();
      setPaxError(validPax[1]);
      return false;
    } else {
      setPaxError(null);
      const params = [];
      params[TRIP_PICKUP] = startAddress;
      params[TRIP_DROPOFF] = endAddress;
      params[TRIP_PAX] = participantString(pax);
      params[TRIP_DATE] = date;
      params[TRIP_TIME] = time;
      params[TRIP_TERMINAL] = terminal;
      dataLayerHandler(TRIP_SEARCH, params);
    }
    return true;
  }

  useEffect(() => {
    handleAbortController();
    apiGet(ENDPOINT_CONFIGS, null, controller).then((results) => {
      setLoading(false);
      setConfigs(results);
      setPax(results.types);
    })
  }, []);

  if (!configs) {
    return <div className="booking bookingPage">
      <div className="container">
        <div className="booking__wrap">
          <Loading />
        </div>
      </div>
    </div>
  }

  return <GoogleMapsAPILoader>
    <form
      method={charter ? 'get' : 'post'}
      action={charter ? configs.charterAction : configs.searchAction}
      onSubmit={validateSubmit}
    >
      <div className="booking">
        <div className="container">
          <div className="booking__wrap">
            <div className="booking__trips">
              <div className="booking__title">
                <div className="booking__headIcon">
                  <IconHeading />
                </div>
                <h3>Trip Details</h3>
              </div>
              <div className="booking__trip__inputs">
                <div className="booking__trip__input input--wide">
                  <label>Pick-up address</label>
                  <LocationSearchField
                    required={true}
                    selectLat={(lat) => {setStartLat(lat)}}
                    selectLng={(lat) => {setStartLng(lat)}}
                    selectAddress={(lat) => {
                      setStartAddress(lat);
                      dataLayerHandler(TRIP_PICKUP, lat);
                    }}
                    selectIsAirport={(is) => {setIsStartAirport(is)}}
                  />
                </div>
                <div className="booking__trip__input input--wide">
                  <label>Drop-off address</label>
                  <LocationSearchField
                    selectLat={(lat) => {setEndLat(lat)}}
                    selectLng={(lat) => {setEndLng(lat)}}
                    selectAddress={(lat) => {
                      setEndAddress(lat);
                      dataLayerHandler(TRIP_DROPOFF, lat);
                    }}
                    selectIsAirport={(is) => {setIsEndAirport(is)}}
                  />
                </div>
                <div className="booking__trip__input input--sm">
                  <label>Passengers</label>
                  <ParticipantInput
                    required={true}
                    onChange={(val) => {
                      setPax(val);
                      dataLayerHandler(TRIP_PAX, participantString(val));
                    }}
                    types={pax}
                    error={paxError}
                  />
                </div>
              </div>
              <div className="booking__trip__inputs">
                <div className="booking__trip__input input--wide date-picker">
                  <label>Date of Travel</label>
                  <input
                    aria-labelledby="date"
                    type="date"
                    min={bookingMinDate()}
                    value={date}
                    name={'date'}
                    required={true}
                    onChange={(e) => {
                      dataLayerHandler(TRIP_DATE, e.target.value);
                      setDate(e.target.value)
                    }}
                  />
                </div>

                {charter && <div className="booking__trip__input input--md time-picker">
                  <label>Pick-up time</label>
                  <TimeField
                    name={`time`}
                    type="time"
                    value={time}
                    required={true}
                    onChange={(val) => {
                      dataLayerHandler(TRIP_TIME, val);
                      setTime(val)
                    }}
                  />
                </div>}

                <div className="booking__trip__input input--wide">
                  {(isStartAirport || isEndAirport) && <>
                    <label>Terminal</label>
                    <select
                      required={true}
                      value={terminal}
                      name={`terminal`}
                      onChange={(e) => {
                        dataLayerHandler(TRIP_TERMINAL, e.target.value);
                        setTerminal(e.target.value)
                      }}
                    >
                      <option value={''}>Select</option>
                      <option value={'Domestic'}>Domestic</option>
                      <option value={'International'}>International</option>
                      <option value={'N/A'}>Not Applicable</option>
                    </select>
                  </>}
                </div>
                <div className="booking__trip__input input--sm">
                  <button
                    type={'submit'}
                    aria-label={'Search'}
                    className="btn btn--lg">
                    {loading ? <Loading /> : 'Search'}
                  </button>
                </div>
              </div>
            </div>

            <input type={'hidden'} name={'s_lat'} value={startLat} aria-labelledby="startLat"/>
            <input type={'hidden'} name={'s_lng'} value={startLng} aria-labelledby="startLng"/>
            <input type={'hidden'} name={'s_add'} value={startAddress} aria-labelledby="startAddress"/>
            <input type={'hidden'} name={'e_lat'} value={endLat} aria-labelledby="endLat" />
            <input type={'hidden'} name={'e_lng'} value={endLng} aria-labelledby="endLng"/>
            <input type={'hidden'} name={'e_add'} value={endAddress} aria-labelledby="endAddress"/>
            <input type={'hidden'} name={'pax'} value={JSON.stringify(pax)} aria-labelledby="pax"/>
          </div>
        </div>
      </div>
    </form>
  </GoogleMapsAPILoader>;
};

export default BookingInitialSearch;
